export default __webpack_public_path__ + "header.webp";